var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.socialData),function(icon){return _c('a',{key:icon.index,style:('width:' + _vm.size + 'px; margin:' + _vm.margin + 'rem;'),attrs:{"href":icon['link'],"target":"_blank"},domProps:{"innerHTML":_vm._s(icon['icon'])}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }